import { el, editable, input } from './domUtils';

export default class FeeCalloutTool {
  static get toolbox() {
    return {
      title: 'Тўлов / давлат божи',
      icon: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none"><path d="M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    };
  }

  static get sanitize() {
    return { amount: {}, label: {}, note: {} };
  }

  constructor({ data }) {
    this.data = { amount: data.amount || '', label: data.label || '', note: data.note || '' };
  }

  render() {
    this.amountEl = input(this.data.amount, 'Масалан: 500 000 сум');
    this.amountEl.classList.add('at-input-strong');
    this.labelEl = input(this.data.label, 'Масалан: Давлат божи');
    this.noteEl = editable(this.data.note, 'Изоҳ...');
    return el('div', { class: 'at-block at-fee-callout' }, [
      el('div', { class: 'at-block-label' }, ['Тўлов блоки']),
      el('div', { class: 'at-row' }, [this.amountEl, this.labelEl]),
      this.noteEl,
    ]);
  }

  save() {
    return {
      amount: this.amountEl.value.trim(),
      label: this.labelEl.value.trim(),
      note: this.noteEl.innerHTML.trim(),
    };
  }
}
